import "./Button.css";

const Button = (props) => {
  return (
    <a
      className={"uibtn hoverable " + props.class}
      href={props.href || "#0"}
      {...(props.href
        ? { target: "_blank", rel: "noopener noreferrer" }
        : {})}
    >
      {props.value}
    </a>
  );
};

export default Button;
